import './Reaction.css'

const Reaction = ({ reaction }) => {
  return <div className="absolute right-0 animation-move-up" style={{ right: `${reaction.offsetX}%` }}>
    <div className="text-3xl animation-wiggle select-none">{reaction.emoji.unicode}</div>
  </div>
}

export default Reaction